import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../../reduxService/hooks';
import { getActionByProjectType } from '../../../../actionMap';
import { selectProjectInfo, setProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import * as utils from '../../../../utils/utils';
import { ISaveButtonProps } from './ISaveButton';
import { IProjectMacra1, IProjectMacra1WithInfo } from '../../../../MACRA_1/store/project/projectSlice';
import { IInitialState } from '../../../../../reduxService';
import { IProjectMacra2, IProjectMacra2WithInfo } from '../../../../MACRA_2/store/project/projectSlice';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Input from '../../../../../components/Input/Input';
import Button from '../../../../../components/Button/Button';
import Spinner from '../../../../../components/Spinner/Spinner';
import './SaveButton.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { endpoint } from '../../../../pages';

const SaveButton = (props: ISaveButtonProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { selectProject, selectProjectWithoutConversion } = getActionByProjectType();
    const dispatch = useAppDispatch();
    const { id } = useParams();

    const project: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProject as any);
    const projectWithoutConversion: IInitialState<IProjectMacra1 | IProjectMacra2> = useAppSelector(selectProjectWithoutConversion as any);
    const projectInfo = useAppSelector(selectProjectInfo);

    const [openSaveCloud, setOpenSaveCloud] = React.useState<boolean>(false);
    const [openSaveLocal, setOpenSaveLocal] = React.useState<boolean>(false);
    const [error, setError] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [projectName, setProjectName] = React.useState<string>('');
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    React.useEffect(() => setProjectName(projectInfo.data?.name || ''), [projectInfo.data?.name]);

    const handleSaveCloud = async () => {
        let projInfoData = { ...projectInfo.data!, name: projectName };
        let idForSave = projectInfo.data?.id ? projectInfo.data.id : !!id ? parseInt(id) : undefined;
        let res = await utils.saveProject({ ...projInfoData, id: idForSave });
        setAnchorEl(null);
        if (!!res && projectInfo.data!.name.toLowerCase() !== projectName.toLowerCase()) {
            navigate(endpoint.designConditionWithId.replace(':id', res.id!.toString()));
        }
    };

    const handleSaveLocal = () => {
        let filename = projectName.replace(' ', '_')!;
        let _project: IProjectMacra1WithInfo | IProjectMacra2WithInfo = {
            projectInfo: { ...projectInfo.data!, name: projectName },
            ...projectWithoutConversion.data!,
        };

        utils.saveFile(filename, JSON.stringify(_project));
        dispatch(setProjectInfo({ ...projectInfo!.data!, name: projectName }));
        setAnchorEl(null);
    };

    const handleSave = async () => {
        if (!!projectName) {
            setLoading(true);

            if (openSaveCloud) {
                await handleSaveCloud();
            }
            if (openSaveLocal) {
                await handleSaveLocal();
            }
            setLoading(false);
        } else {
        }
    };

    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-solid fa-floppy-disk' />
                {t('header_save_button')}
                <i className='fa-solid fa-angle-down' />
            </button>

            <Menu
                id='basic-menu-save'
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem className={props.className} onClick={() => setOpenSaveCloud(true)}>
                    {t('header_save_button_cloud')}
                </MenuItem>
                <MenuItem className={props.className} onClick={() => setOpenSaveLocal(true)}>
                    {t('header_save_button_computer')}
                </MenuItem>

                {(openSaveCloud || openSaveLocal) && (
                    <Dialog className='dialog-save' open={openSaveCloud || openSaveLocal}>
                        <DialogTitle>{openSaveCloud ? t('header_save_button_cloud') : t('header_save_button_computer')}</DialogTitle>
                        <DialogContent className='dialog-save-content'>
                            <Input
                                type='text'
                                required
                                defaultValue={projectName}
                                name='name'
                                title={t('project_info_project_detail_project_name')}
                                onChange={e => {
                                    let value = e.target.value;
                                    if (!value) {
                                        setError(true);
                                    } else {
                                        setError(false);
                                    }
                                    setProjectName(e.target.value);
                                }}></Input>
                            {error && <span>{t('project_info_formik_required')}</span>}
                        </DialogContent>
                        <DialogActions className='dialog-save-action'>
                            <Button
                                onClick={() => {
                                    setOpenSaveCloud(false);
                                    setOpenSaveLocal(false);
                                    setProjectName(projectInfo.data?.name || '');
                                }}>
                                {t('cancel_button')}
                            </Button>
                            {loading ? (
                                <Spinner />
                            ) : (
                                <Button disabled={loading} onClick={handleSave}>
                                    {t('header_save_button')}
                                </Button>
                            )}
                        </DialogActions>
                    </Dialog>
                )}
            </Menu>
        </>
    );
};

export default SaveButton;
